import React, { PropTypes } from "react";
import { reduxForm, Field } from "redux-form";
import { Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import userHasAccess from "../../../utils/userHasAccess";
import { AGENT } from "../../../utils/Roles";
import validationUtils from "../../../utils/ValidationUtils";

import { TextInput } from "./";

function generateLocalizedRules(fieldName, values, validationRules) {
  const localizedFields = [fieldName];
  let newRules = { ...validationRules };

  localizedFields.map((field) => {
    Object.keys(values.localizations).map((locale) => {
      const fieldName = `localizations['${locale}'].${field}`;

      newRules[fieldName] = newRules[field];
    });
  });
  localizedFields.map((field) => {
    delete newRules[field];
  });

  return newRules;
}

class EndUserFormMessageConfiguration extends React.Component {
  constructor(props) {
    super(props);

    const areFieldsUnlocked =
      props.initialValues.localizations[
        Object.keys(props.initialValues.localizations)[0]
      ][props.localizedFieldName];

    this.state = {
      readOnly: !!areFieldsUnlocked,
    };

    this.lock = this.lock.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.unlock = this.unlock.bind(this);
  }

  lock() {
    this.setState({ readOnly: true });
  }

  unlock() {
    this.setState({ readOnly: false });
  }

  resetForm() {
    const { reset } = this.props;

    reset();
    this.lock();
  }

  submitForm() {
    const { handleSubmit } = this.props;

    if (!handleSubmit()) {
      this.lock();
    }
  }

  render() {
    const {
      fieldType,
      formTitle,
      initialValues,
      localizedFieldName,
      disableBtn
    } = this.props;
    const { readOnly } = this.state;
    const isRoleAuthorized = !userHasAccess(AGENT, true);

    return (
      <div className="message-subform">
        {formTitle}
        <div className="intl-field-group">
          {Object.keys(initialValues.localizations).map((locale) => (
            <Field
              key={locale}
              groupClassName={`intl ${locale.substr(0, 2)} ${fieldType}`}
              id={`localizations['${locale}'].['${localizedFieldName}']`}
              name={`localizations['${locale}'].['${localizedFieldName}']`}
              component={TextInput}
              componentClass={fieldType}
              type={fieldType}
              disabled={readOnly || !isRoleAuthorized}
            />
          ))}
        </div>
        {(readOnly && isRoleAuthorized) && (
          <Button bsStyle="primary" onClick={this.unlock}>
            <FormattedMessage id="common.edit" />
          </Button>
        )}
        {(!readOnly && isRoleAuthorized) && (
          <span className="buttons">
            <Button disabled={disableBtn} bsStyle="primary" onClick={this.submitForm}>
              <FormattedMessage id="common.save" />
            </Button>
            <Button bsStyle="default" onClick={this.resetForm}>
              <FormattedMessage id="common.cancel" />
            </Button>
          </span>
        )}
      </div>
    );
  }
}

EndUserFormMessageConfiguration.propTypes = {
  fieldType: PropTypes.string,
  formTitle: PropTypes.node,
  form: PropTypes.string.isRequired,
  localizedFieldName: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  validationRules: PropTypes.object.isRequired,
  // props from redux-form
  reset: PropTypes.func,
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  disableBtn: PropTypes.bool
};

export default reduxForm({
  validate: (values, props) =>
    validationUtils.validate(
      values,
      generateLocalizedRules(
        props.localizedFieldName,
        values,
        props.validationRules
      )
    ),
  enableReinitialize: true,
})(EndUserFormMessageConfiguration);



// WEBPACK FOOTER //
// ./src/components/common/form/EndUserFormMessageConfiguration.js